import { gql } from "@apollo/client";

export const GET_DIVISION_NAME = gql`
query FindDivisionByUuid($uuid: ID!) {
    findDivisionByUuid(uuid: $uuid) {
      name
    }
  }
    `


    export const GET_LOCATION_NAME = gql`
query FindLocationByUuid($uuid: ID!) {
  findLocationByUuid(uuid: $uuid) {
    locationName
  }
}
    `

export const GET_PLATFORM_VIDEO_URL = gql`
query GetPlatformVideoUrl($filename: String!) {
  getPlatformVideoUrl(filename: $filename) {
    url
  }
}
    `